import {Media} from "./media";
import {Task} from "./task";
import {BaseModel} from "./base-model";
import {Step} from "./step";
import {Equipment} from "./equipment";
import {Skill, SkillLevel} from './skill';

export enum ProcedureType {
  TEXT,
  VIDEO,
  MIXED_REALITY
}

export class Procedure extends BaseModel {

  protected static self = Procedure;

  id : string;
  name : string;
  description : string;
  hasVideo: boolean;
  hasSpatial: boolean;
  modelId : string;
  equipmentModel : Equipment;
  tasksTotal : number;
  isErasable: boolean;
  requiredSkill: ProcedureRequiredSkill;

  videoUrl: string;
  tasks: Task[];

  get types(): ProcedureType[] {

    const types = [ ProcedureType.TEXT ];

    if (this.hasVideo) {
      types.push(ProcedureType.VIDEO);
    }

    if (this.hasSpatial) {
      types.push(ProcedureType.MIXED_REALITY);
    }

    return types;

  }

  set types(types: ProcedureType[]) {
    this.hasVideo = types.includes(ProcedureType.VIDEO);
    this.hasSpatial = types.includes(ProcedureType.MIXED_REALITY);
  }

  // TODO
  public validate(): boolean {
    return true;
  }
}

export class ProcedureRequiredSkill {
  skill: Skill;
  skillLevel: SkillLevel;
}
